import { BatchSpanProcessor, WebTracerProvider, } from "@opentelemetry/sdk-trace-web";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { trace, context, defaultTextMapSetter } from '@opentelemetry/api';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import Cookies from "js-cookie";
import { Resource } from '@opentelemetry/resources';
const buildingWithoutTrace = false;
let providerCache = { __token: null };
function createProvider() {
    const token = Cookies.get('token');
    if (token === providerCache?.__token)
        return providerCache;
    const collectorOptions = {
        serviceName: "alpha-vision-web", // The name of the service
        url: "https://gw-apm.agi7.ai/v1/traces", // url is optional and can be omitted - default is http://localhost:4318/v1/traces
        headers: { Authorization: `Bearer ${token}` }, // an optional object containing custom headers to be sent with each request
        concurrencyLimit: 10, // an optional limit on pending requests
    };
    let env;
    try {
        //@ts-ignore
        const envStr = window.agi7Info || window.location.host;
        //In some situation, chances are that the envStr is loaded before agi7Info, so judge with host
        if (envStr.indexOf('test') !== -1) {
            env = 'test';
        }
        else if (envStr.indexOf('dev') !== -1 || envStr.indexOf('demo') !== -1) {
            env = 'dev';
        }
        else if (process?.env?.NODE_ENV === 'production') {
            env = 'prod';
        }
        else {
            env = 'dev';
        }
    }
    catch (e) {
        env = "dev";
        console.warn(e);
    }
    const provider = new WebTracerProvider({
        resource: new Resource({
            "service.name": 'web',
            "env": env
        }),
    });
    const exporter = new OTLPTraceExporter(collectorOptions);
    provider.addSpanProcessor(new BatchSpanProcessor(exporter, {
        // The maximum queue size. After the size is reached spans are dropped.
        maxQueueSize: 100,
        // The maximum batch size of every export. It must be smaller or equal to maxQueueSize.
        maxExportBatchSize: 10,
        // The interval between two consecutive exports
        scheduledDelayMillis: 5000,
        // How long the export can run before it is cancelled
        exportTimeoutMillis: 30000,
    }));
    provider.register({});
    //@ts-ignore
    provider.__token = token;
    providerCache = provider;
    return provider;
}
export class FakeTracerProvider {
    startCodecSpans(codecs) { }
    endCodecSpan(codec, code) { }
    startAllSpan(reconnect) { }
    endAllSpan(code, attributes) { }
    endPeerConnection(code) { }
    endIceConnection(code) { }
    endOffer(code) { }
    resetOfferStartTime() { }
}
export class TracerProvider {
    constructor(attributes, debugging) {
        this.webTracer = createProvider().getTracer('webrtc-web-tracer');
        this.attributes = attributes;
        this.debugging = debugging;
        this.codecSpans = {};
    }
    startCodecSpans(codecs) {
        codecs.forEach((codec) => {
            const codecSpan = this.webTracer.startSpan("checkSupportedVideoCodec");
            codecSpan.setAttributes(Object.assign({ codec }, this.attributes));
            this.codecSpans[codec] = codecSpan;
        });
        return true;
    }
    endCodecSpan(codec, code) {
        if (!this.codecSpans[codec]) {
            return false;
        }
        this.codecSpans[codec].setStatus({ code });
        this.codecSpans[codec].end();
        delete this.codecSpans[codec];
        return true;
    }
    startAllSpan(reconnect = false) {
        let peerConnectionName = "peer-connection";
        let iceConnectionName = "ice-connection";
        let offerName = "offer";
        if (reconnect) {
            peerConnectionName = "peer-connection-reconnect";
            iceConnectionName = "ice-connection-reconnect";
            offerName = "offer-reconnect";
        }
        this.peerConnectionSpan = this.webTracer.startSpan(peerConnectionName);
        this.peerConnectionSpan.setAttributes(this.attributes);
        this.ctx = trace.setSpan(context.active(), this.peerConnectionSpan);
        this.propagator = new W3CTraceContextPropagator();
        context.with(this.ctx, () => {
            this.iceSpan = this.webTracer.startSpan(iceConnectionName);
            this.offerSpan = this.webTracer.startSpan(offerName);
            this.iceSpan.setAttributes(this.attributes);
            this.offerSpan.setAttributes(this.attributes);
        });
        const headers = {};
        this.propagator.inject(this.ctx, headers, defaultTextMapSetter);
        this.traceHeaders = headers;
        if (this.debugging)
            console.log("traceHeaders", this.traceHeaders);
        return true;
    }
    endAllSpan(code, attributes) {
        if (!this.peerConnectionSpan || !this.iceSpan || !this.offerSpan) {
            console.error("span not started");
            return false;
        }
        this.peerConnectionSpan.setStatus({ code });
        this.iceSpan.setStatus({ code });
        this.offerSpan.setStatus({ code });
        this.peerConnectionSpan.setAttributes(attributes);
        this.iceSpan.setAttributes(attributes);
        this.offerSpan.setAttributes(attributes);
        this.peerConnectionSpan.end();
        this.iceSpan.end();
        this.offerSpan.end();
        return true;
    }
    endPeerConnection(code) {
        if (!this.peerConnectionSpan) {
            console.error("peerConnectionSpan not started");
            return false;
        }
        this.peerConnectionSpan.setStatus({ code });
        this.peerConnectionSpan.end();
        return true;
    }
    endIceConnection(code) {
        if (!this.iceSpan) {
            console.error("iceSpan not started");
            return false;
        }
        this.iceSpan.setStatus({ code });
        this.iceSpan.end();
        return true;
    }
    endOffer(code) {
        if (!this.offerSpan) {
            console.error("offerSpan not started");
            return false;
        }
        this.offerSpan.setStatus({ code });
        this.offerSpan.end();
        return true;
    }
    resetOfferStartTime() {
        if (!this.offerSpan) {
            console.error("offerSpan not exist");
            return false;
        }
        const timeStampStr = new Date().getTime().toString();
        // @ts-ignore
        this.offerSpan.startTime[0] = Number(timeStampStr.substring(0, 10));
        // @ts-ignore
        this.offerSpan.startTime[1] = Number(timeStampStr.substring(10) + '000000');
        return true;
    }
    ;
}
export function createTraceInstance(...args) {
    if (buildingWithoutTrace) {
        return new FakeTracerProvider();
    }
    //@ts-ignore
    return new TracerProvider(...args);
}
